import { OEText } from '@openeducation/oe-it-components';
import { styled, secondaryFontFamily } from '@openeducation/oe-it-themes';
import React from 'react';
import type { StyleProp, ViewStyle } from 'react-native';

type TitleType = 'light' | 'medium' | 'dark';
type TextType = 'dark' | 'primary' | 'warning';
type TextSize = 'regular' | 'large';

export interface InfoItemProps {
  title?: string;
  text?: string | null;
  style?: StyleProp<ViewStyle>;
  titleType?: TitleType;
  textType?: TextType;
  textSize?: TextSize;
  children?: React.ReactNode;
}

export const InfoItem = ({
  title,
  text,
  style,
  children,
  titleType = 'light',
  textType = 'dark',
  textSize = 'regular',
}: InfoItemProps) => {
  return (
    <Container style={style}>
      {!!title && <Title titleType={titleType}>{title}</Title>}
      {!!text && (
        <Text textSize={textSize} textType={textType}>
          {text}
        </Text>
      )}
      {children}
    </Container>
  );
};

const Container = styled.View`
  flex-direction: column;
`;

interface TitleProps {
  titleType: TitleType;
}

const Title = styled(OEText).attrs<TitleProps>(({ theme, titleType }) => ({
  fontFamily: secondaryFontFamily,
  color:
    titleType === 'light'
      ? theme.color.dark3
      : titleType === 'medium'
      ? theme.color.dark2
      : theme.color.dark1,
  fontSize: 12,
  fontType:
    titleType === 'light'
      ? 'regular'
      : titleType === 'medium'
      ? 'semiBold'
      : 'bold',
}))<TitleProps>`
  text-transform: uppercase;
  letter-spacing: 1px;
`;

interface TextProps {
  textType: TextType;
  textSize: TextSize;
}

const Text = styled(OEText).attrs<TextProps>(
  ({ theme, textType, textSize }) => ({
    fontFamily: secondaryFontFamily,
    color:
      textType === 'primary'
        ? theme.color.primary
        : textType === 'warning'
        ? theme.color.sunnyOrangeLight
        : theme.color.dark1,
    fontSize: textSize === 'regular' ? 18 : 26,
    fontType: 'bold',
  })
)<TextProps>``;
